import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

import { resetContainerPaddings } from "utils/styles";

const processSectionStyles = {
  wrapper: (): SystemStyleObject<Theme> => ({
    display: "flex",
    flexDirection: { md: "column" },
    justifyContent: "center",
    gap: 2,
    position: "relative",
  }),
  barWrapper: (): SystemStyleObject<Theme> => ({
    height: { xs: "100%", md: 75 },
    width: { xs: 60, md: `calc(100% + ${resetContainerPaddings} * -1)` },
    position: "absolute",
    top: { xs: 0, md: "20%" },
    left: 0,
    ml: { md: resetContainerPaddings },
  }),
  bar: (theme: Theme): SystemStyleObject<Theme> => ({
    width: "100%",
    height: "100%",
    backgroundImage: `
      url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/common/texture.png),
      linear-gradient(180deg, ${theme.palette.primary.dark}, ${theme.palette.primary.dark})
    `,
    backgroundBlendMode: "screen",
  }),
  barSlider: (theme: Theme): SystemStyleObject<Theme> => ({
    width: "100%",
    height: "100%",
    position: "absolute",
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.background.default,
  }),
  index: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gap: 3,
    gridRow: 1,
    gridColumn: 1,
    gridTemplateRows: { xs: "repeat(4, 1fr)", md: "auto" },
    gridTemplateColumns: { md: "repeat(4, 1fr)" },
    justifyItems: { xs: "center", md: "unset" },
  }),
  indexText: (): SystemStyleObject<Theme> => ({
    fontWeight: 900,
    fontSize: { xs: 80, md: 160, lg: 200 },
    lineHeight: 1,
    textShadow: "7px 4px 13px rgba(0, 0, 0, 0.5);",
  }),
  label: (): SystemStyleObject<Theme> => ({
    display: "grid",
    gap: 3,
    gridTemplateColumns: { md: "repeat(4, 1fr)" },
    gridTemplateRows: { xs: "repeat(4, 1fr)", md: "auto" },
    alignItems: { xs: "center", md: "start" },
  }),
  labelText: (): SystemStyleObject<Theme> => ({
    fontWeight: 400,
  }),
};

export default processSectionStyles;
